import type { TenantSlug } from "@/hooks/useTenant";

const BASE_BY_TENANT: Record<TenantSlug, string> = {
  dev: "https://aurora-app-client-dev.use1-offboard-dev01.ob.dev.cloud.aurora.tech",
  staging: "https://aurora-app-client-staging.use1-offboard-stg01.ob.dev.cloud.aurora.tech",
  "pre-prod": "https://aurora-app-client-pre-prod.use1-offboard-pre-prod01.ob.pre-prod.cloud.aurora.tech",
  prod: "https://app.aurora.tech",
};

/** Build the external Aurora trip URL for the given tenant. Returns null if id is empty. */
export function getAuroraTripUrl(tenant: TenantSlug, externalId: string | null | undefined): string | null {
  if (!externalId) return null;
  const base = BASE_BY_TENANT[tenant] ?? BASE_BY_TENANT.prod;
  return `${base}/trips/${encodeURIComponent(externalId)}`;
}